import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { NCSample } from './nc-sample';
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap, map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NCImage } from './nc-image';
import { BoxDetails } from '../apg-deliver-box-manager/boxDetails';

@Injectable()
export class  ApgNcSampleService { 

  constructor(private http: HttpClient) {
  }

  saveNCSample(ncSample: NCSample): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + "nc-sample";
    return this.http.post<BBResponseContainer>(url, ncSample).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateNCSample(ncSample: NCSample): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + "nc-sample";
    return this.http.put<BBResponseContainer>(url, ncSample).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  associateToBatch(ncSample: NCSample): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + "nc-sample/batch-association";
    return this.http.post<BBResponseContainer>(url, ncSample).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  searchNCSamples(query: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + 'nc-sample';
    let requestParam = new HttpParams().set('queryString', query);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  updatedNCSamplesAsReported(lab: string, query: string, labName: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + 'nc-sample/'+lab+'?sender=' + query+'&labName='+labName;
    return this.http.patch<BBResponseContainer>(url, null).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  updatedNCSampleCommentsAndResponse(ncSample:any): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + 'nc-sample/customerresponse';
    return this.http.patch<BBResponseContainer>(url, ncSample).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  downloadReport(query: string) {
    return this.http.get(environment.BB_APG_NC_HANDLING_URL + 'nc-sample/report/?queryString=' + query, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    );
  }

  downloadDailyReport(lab: string,query:string) {
    return this.http.get(environment.BB_APG_NC_HANDLING_URL + 'nc-sample/report/'+lab+'/dailyreport/?sender=' + query, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    );
  }

  downloadImageArchive(lab: string,query:string) {
    return this.http.get(environment.BB_APG_NC_HANDLING_URL + 'nc-sample/report/'+lab+'/images/?sender=' + query, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    );
  }

  uploadImage(ncImage: NCImage): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + "nc-sample/upload-image";
    return this.http.post<BBResponseContainer>(url, ncImage).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  downloadImages(id: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + "nc-sample/download-images";    
    let requestParam = new HttpParams().set('id', id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    })); 
  }

  validateBoxId(lab: string, boxId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/boxID';
    let requestParam = new HttpParams().set('lab', lab).set('boxId', boxId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  validateBarcode(lab: string, barcode: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + 'nc-sample/validate/barcode';
    let requestParam = new HttpParams().set('labId', lab).set('scannedBarcode', barcode).set('isBarcodeExistanceCheckRequired', 'false');
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  searchBox(lab: string, boxId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/boxsearch/boxID';
    let requestParam = new HttpParams().set('lab', lab).set('boxId', boxId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateBoxDetails(boxShortInfo: BoxDetails): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/save/boxID";
    return this.http.patch<BBResponseContainer>(url, boxShortInfo).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  downloadImageArchiveSenders(lab: string, sender:string, senderGroup:string[]) {
    return this.http.get(environment.BB_APG_NC_HANDLING_URL + 'nc-sample/senders/report/'+lab+'/images/?sender=' + sender+'&senderGroup='+senderGroup, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    );
  }

  downloadDailyReportForSenders(lab: string, sender:string, group:string, senderGroup:string[]) {
    return this.http.get(environment.BB_APG_NC_HANDLING_URL + 'nc-sample/senders/report/'+lab+'/dailyreport/?sender=' + sender+'&group='+group+'&senderGroup='+senderGroup, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    );
  }

  updatedNCSamplesAsReportedForSenders(lab: string, query: string, labName: string,  senderGroup:string[]): Observable<BBResponseContainer> {
    let url = environment.BB_APG_NC_HANDLING_URL + 'nc-sample/'+lab+'?sender=' + query+'&labName='+labName+'&senderGroup='+senderGroup;
    return this.http.patch<BBResponseContainer>(url, null).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
}